import { Builder } from "@builder.io/sdk";
import { useRouter } from "next/router";

import { analytics } from "@flare/analytics";
import { useTranslation } from "@flare/i18n";
import { Icon } from "@flare/ui/components";
import { cn } from "@flare/ui/utils";

import { FUNNEL_BACK_BUTTON } from "@/builder/components-sections";
import type { FunnelAnswers, Steps } from "@/modules/v2/funnel/config";
import { useFunnelAnswers } from "@/modules/v2/funnel/hooks/useFunnelAnswers";
import { BiEventsNames } from "@/services/analytics/bi-event-names";
import { isDirectCampaignTraffic } from "@/services/store/campaign-data-context/campaign-data-utils";

export const BackButton = () => {
  const router = useRouter();
  const { t } = useTranslation();

  const isDirectTraffic = isDirectCampaignTraffic(router.query);
  const { query } = useRouter();
  const practice = query?.practice as FunnelAnswers["practice"];
  const step = query?.step as Steps;
  const { funnelAnswers } = useFunnelAnswers();
  const data = funnelAnswers ? funnelAnswers : {};

  function handleBackClick() {
    analytics.track(BiEventsNames.WebFunnelClick, {
      practice,
      current_step_key: step,
      answer_value: Object.entries(data).flat().toString(),
      full_answer: JSON.stringify(data),
      click_type: "back",
      click_text: "back_button",
    });
    router.back();
  }

  return (
    <button
      type="button"
      onClick={handleBackClick}
      className={cn("flex items-center gap-sp-2", {
        invisible: isDirectTraffic,
      })}
    >
      <Icon name="chevron-left" />
      {t("FUNNEL_BACK_BUTTON")}
    </button>
  );
};

Builder.registerComponent(BackButton, {
  name: FUNNEL_BACK_BUTTON,
});
